export enum GmsConnection {
    UPLOAD = 'upload',
    STRONG = 'strong',
    GOOD = 'good',
    OK = 'ok',
    WEAK = 'weak',
    NO_SIGNAL = 'no-signal'
}